import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPrice = () => {
    document.getElementById('price-block')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-[#faf8f0] overflow-hidden" data-id="element-79">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#f0ebe0] opacity-50 skew-x-12 transform origin-top-right hidden lg:block" data-id="element-80" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 relative z-10" data-id="element-81">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-82">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-83">
            <span className="inline-block py-1 px-3 rounded-full bg-[#e8f5e9] text-[#2d5a3d] text-sm font-semibold tracking-wide mb-6 border border-[#2d5a3d]/20" data-id="element-84">
              New Release: 2024 Edition
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1a3c2a] leading-tight mb-6" data-id="element-85">
              Natural Remedies Encyclopedia:{' '}
              <span className="text-[#c9a84c] italic" data-id="element-86">Fix 90%</span> of Family
              Health Issues From Your Kitchen
            </h1>
            <p className="text-xl text-[#5c4a32] mb-8 font-medium" data-id="element-87">
              200+ Recipes • Symptom Matrix • No Doctors or Pharmacies Needed
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-88">
              <button onClick={scrollToPrice} className="group bg-[#1a3c2a] text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg hover:bg-[#2d5a3d] hover:shadow-xl hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2" data-id="element-89">
                Get Your Symptom Matrix Now
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" />
              </button>
            </div>
            <p className="mt-4 text-sm text-[#5c4a32]/80" data-id="element-91">
              Instant Digital Download • 30-Day Money-Back Guarantee
            </p>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-92">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-93">
              <img src="https://cdn.magicpatterns.com/uploads/xdFnvgWNnh78VitEhQi6jh/remdios_naturales_portada.png" alt="Natural Remedies Encyclopedia on a tablet in a kitchen setting" className="w-full h-auto object-cover" data-id="element-94" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-95" />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-[#c9a84c] text-white p-4 rounded-full shadow-lg w-24 h-24 flex items-center justify-center text-center font-bold text-sm border-4 border-[#faf8f0] hidden md:flex animate-bounce-slow" data-id="element-96">
              200+ <br data-id="element-97" />
              Recipes
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}